import { create } from 'zustand';

const SESSION_STORAGE_KEY = 'login_session_expires_at';
const DEFAULT_TIMEOUT_MINUTES = 15;

interface LoginSessionState {
  // Timestamp de cuando expira la sesión de login
  expiresAt: number | null;
  // Identifier (email/phone) para el cual se inició
  identifier: string | null;
  
  // Acciones
  startSession: (identifier: string, timeoutMinutes?: number) => void;
  clearSession: () => void;
  isExpired: () => boolean;
  getRemainingSeconds: () => number;
  restoreSession: () => void;
}

export const useLoginSessionStore = create<LoginSessionState>((set, get) => ({
  expiresAt: null,
  identifier: null,

  startSession: (identifier: string, timeoutMinutes = DEFAULT_TIMEOUT_MINUTES) => {
    const expiresAt = Date.now() + timeoutMinutes * 60 * 1000;
    sessionStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify({ expiresAt, identifier }));
    set({ expiresAt, identifier });
    console.log('[LoginSession] Started session for', identifier, 'expires at', new Date(expiresAt).toISOString());
  },

  clearSession: () => {
    sessionStorage.removeItem(SESSION_STORAGE_KEY);
    set({ expiresAt: null, identifier: null });
    console.log('[LoginSession] Session cleared');
  },

  isExpired: () => {
    const { expiresAt } = get();
    if (!expiresAt) return false;
    return Date.now() > expiresAt;
  },

  getRemainingSeconds: () => {
    const { expiresAt } = get();
    if (!expiresAt) return 0;
    const remaining = Math.max(0, Math.ceil((expiresAt - Date.now()) / 1000));
    return remaining;
  },

  restoreSession: () => {
    try {
      const stored = sessionStorage.getItem(SESSION_STORAGE_KEY);
      if (stored) {
        const { expiresAt, identifier } = JSON.parse(stored);
        if (expiresAt && Date.now() < expiresAt) {
          set({ expiresAt, identifier });
          console.log('[LoginSession] Session restored for', identifier);
        } else {
          // Sesión expirada, limpiar
          sessionStorage.removeItem(SESSION_STORAGE_KEY);
        }
      }
    } catch (e) {
      console.error('[LoginSession] Error restoring session:', e);
      sessionStorage.removeItem(SESSION_STORAGE_KEY);
    }
  }
}));
